export const TEMPLATE_PICKER_QUERY_PARAM = 'openTemplatePicker';
export const NEW_WHITEBOARD_QUERY_PARAM = 'isNewWhiteboard';
export const INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM = 'insertTemplateWithKey';
export const HEADLESS_QUERY_PARAM = 'headless';
export const SERVER_SPOT_PARAM = 'canvas-server';
export const RELAY_SPOT_PARAM = 'canvas-relay';
export const WHITEBOARD_IFRAME_TITLE = 'whiteboard-frame';
export const WHITEBOARD_LOCALE = 'whiteboard-locale';
export const WHITEBOARD_LINKED_OBJECT = 'whiteboard-linked-object';
export const INITIAL_THEME_PARAM = 'initial-theme';
export const BIFROST_OVERRIDE_PARAM = 'bifrost-override';
export const PAYWALL_DEACTIVATION_IDENTIFIER = 'deactivationIdentifier';
export const WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID = 'whiteboardPaywallUpsellButton';
export const WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID = 'whiteboardPaywallLearnMoreButton';
export const WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX = 'whiteboardCreationPaywall-';

export const JIRA_IMPORT_TOOL_QUERY_PARAM = 'openJiraImportTool';
export const AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM = 'autoImportJiraIssues';
export const JIRA_IMPORT_JQL = 'jiraImportJql';
export const MIRO_IMPORT_TOOL_QUERY_PARAM = 'openMiroImportTool';
export const MURAL_IMPORT_TOOL_QUERY_PARAM = 'openMuralImportTool';
/**
 * Currently used for Jira import functionality (auto-import and pre-opening modal)
 * @see {@link JIRA_IMPORT_TOOL_QUERY_PARAM}
 * @see {@link AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM}
 */
export const CLOUD_ID = 'cloudId';
export const PROJECT_UUID = 'projectUuid';
export const WHITEBOARD_GA_LAUNCH_DATE: Date = new Date('2024-02-29T00:00Z');
export const PARENT_PRODUCT_QUERY_PARAM = 'parentProduct';
export const PARENT_DOMAIN_QUERY_PARAM = 'parentDomain';
export const PRESENTATION_MODE_QUERY_PARAM = 'presentationMode';
export const EMBEDDED_THEME_STATE = 'themeState';
/**
 * In order for tokens to match the parent product, we will send down the value of fg('platform-component-visual-refresh') via
 * query params as that will be more performant than waiting for feature gates to load and get evaluated on app start up.
 */
export const VISUAL_REFRESH_PARAM = 'visualRefresh';
/** Used by the embedded Whiteboard view to show creation time (eg "Created 4 days ago").
 *
 *  Currently this is provided by Whiteboard's smart-link resolver and is passed down to the Whiteboard iframe URL by CFE
 */
export const EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM = 'createdAt';
export const FOCUSED_COMMENT_ID = 'focusedCommentId';
export const FOCUSED_MENTION_ID = 'focusedMentionId';
export const REPLY_TO_COMMENT = 'replyToComment';
export const WHITEBOARD_VERSION_ID = 'version';

export type PaywallButtonActionTypes = 'active' | 'redirect' | 'viewOnly' | 'close';

/**
 * Used to compute the link to return to after creating a whiteboard via `/` command
 */
export const CREATED_FROM_SLUG = 'createdFromSlug';

/**
 * Turns out the layout debugger in whiteboards - A tool for visualizing the sizes
 * and layouts of elements in Whiteboards
 */
export const DEBUG_LAYOUTS_QUERY_PARAM = 'debugLayouts';
/**
 * Specific to the Confluence Race mode feature, which prevents the template picker from opening when present
 */
export const RACING_QUERY_PARAM = 'racing';

/**
 * When true, passes slides mode down to the Whiteboards iframe (e.g. for presentation/slides view).
 */
export const SLIDES_QUERY_PARAM = 'slides';

/**
 * When true, tells the Whiteboards iframe to hide its own border (e.g. when embedded in native embeds
 * so only the host wrapper border is visible).
 */
export const HIDE_BORDER_QUERY_PARAM = 'hideBorder';

/**
 * Indicates whether the whiteboard is being viewed in embedded mode. Can be true or false.
 */
export const EMBED_QUERY_PARAM = 'embed';

/**
 * When true, indicates the whiteboard is being viewed inside a native embed view.
 */
export const NATIVE_EMBED_VIEW_QUERY_PARAM = 'nativeEmbedView';
